
const hideThumbnailOnScroll = () => {
	const sidebarContent = document.querySelector('.wp-block-blog__sidebar-trigger');

	const observer = new IntersectionObserver(
		( records, observer ) => {
			for(const record of records) {
				const stickyTarget = record.target.parentElement.querySelector('.wp-block-blog__sidebar-inner-content');
				const offsetHeight = stickyTarget.querySelector('.wp-block-blog__sidebar-thumbnail img').clientHeight;

				// Plus 16px for grid gap, plus one more to round up the image height
				stickyTarget.style = `--offsetHeight: ${offsetHeight + 17}`;

				stickyTarget.classList.toggle('isSticky', record.intersectionRatio > 1 );
				if ( record.intersectionRatio < 1 ) {
					stickyTarget.classList.toggle('isSticky');
				}
			}
		},
		{
			threshold: [1],
		}
	);

	observer.observe(sidebarContent);
}

window.addEventListener('DOMContentLoaded', () => {
	hideThumbnailOnScroll();
})